import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { authService } from '@S';

import services from './data';

let CategoryOptions;

const ChartList = (props) => {
  const [options, setOptions] = useState([]);
  const omc_id = authService.currentOMC;

  useEffect(() => {
    services
      .getChartList(omc_id)
      .then((response) => {
        const tmp = response.data.data.results;
        CategoryOptions = [];
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            value: tmp[i].uuid,
            label: tmp[i].name,
          });
        }
        setOptions(CategoryOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleChange = (selectedOption) => {
    const id = props.did ? props.did : 0;
    props.handleChartChange(selectedOption, id);
  };

  return (
    <Select
      onChange={handleChange}
      isClearable={true}
      options={options}
      className="select-box-container"
      classNamePrefix="raw-select"
      name="calibration_chart_name"
      placeholder="Select chart name"
      value={options.filter(({ value }) => value === props.value)}
      isDisabled={props.disabled || false}
      menuPortalTarget={document.body}
    />
  );
};

export { ChartList };
